import React, { useEffect, useRef, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { formatMoneyToCZK } from '@utils/cart.utils';
import moment from 'moment';
import { IColors, IDate, ITicket } from '../../interfaces/Conference';
import { calendarApi } from '../../services/calendar.service';
import {
    Count,
    InputCount,
    Minus,
    Plus,
    Ticket,
    TicketButtons,
    TicketButtonsHeader,
    TicketContent,
    TicketDetails,
    TicketPrice,
    TicketTitle,
    TicketsHeader,
} from './ConferenceOrderTickets.elements';

interface ConferenceProps {
    colors?: IColors;
    ticket?: ITicket;
    index?: number;
    handleSetCountTickets?: Function;
}

const ConferenceOrderTicketTemplate: FC<ConferenceProps> = ({ colors, ticket, index, handleSetCountTickets }) => {
    const { t } = useTranslations();

    const [date, setDate] = useState<IDate>();

    const [totalPrice, setTotalPrice] = useState(0);

    const nameInputRef = useRef<HTMLInputElement>();

    const loadDateByKey = async (dateKey: string) => {
        const response = await calendarApi.getDateData(dateKey);
        setDate(response.data);
    };

    useEffect(() => {
        if (ticket?.date?._key) {
            loadDateByKey(ticket?.date?._key);
        }
    }, [ticket?.date?._key]);

    const priceTicket = date?.modules?.filter((item) => item?.type === 0);
    const a = moment(date?.eventDate?.to);
    const b = moment(date?.eventDate?.from);
    const diffDays = a.diff(b, 'days') + 1;

    const handlePlus = async () => {
        nameInputRef.current.value = String(Number(nameInputRef?.current?.value) + 1);
        const totalPrice = Number(nameInputRef?.current?.value) * Number(priceTicket[0]?.price_with_vat);
        setTotalPrice(totalPrice);
        handleSetCountTickets({
            count: Number(nameInputRef?.current?.value),
            key: ticket?.date?._key,
            name: ticket?.name,
            totalPrice: totalPrice,
        });
    };

    const handleMinus = async () => {
        if (Number(nameInputRef?.current?.value) > 0) {
            nameInputRef.current.value = String(Number(nameInputRef?.current?.value) - 1);
            const totalPrice = Number(nameInputRef?.current?.value) * Number(priceTicket[0]?.price_with_vat);
            setTotalPrice(totalPrice);
            handleSetCountTickets({
                count: Number(nameInputRef?.current?.value),
                key: ticket?.date?._key,
                name: ticket?.name,
                totalPrice: totalPrice,
            });
        }
    };

    return (
        <Ticket>
            <TicketTitle>
                {ticket.name}
                {` `}
                {diffDays > 1 && (
                    <>
                        ({diffDays} {t('conference.general.countDays')})
                    </>
                )}
            </TicketTitle>

            <TicketContent>
                <TicketsHeader colors={colors} index={index}>
                    <TicketPrice>{t('conference.general.priceVat')}</TicketPrice>
                    <TicketButtonsHeader>{t('conference.general.count')}</TicketButtonsHeader>
                    <TicketPrice>{t('conference.general.priceVatTotal')}</TicketPrice>
                </TicketsHeader>

                <TicketDetails>
                    <TicketPrice>{priceTicket?.length > 0 && date?.eventDate?.state === 0 ? `${formatMoneyToCZK(priceTicket[0].price_with_vat)} Kč` : '-'}</TicketPrice>

                    <TicketButtons>
                        <Minus onClick={handleMinus}>-</Minus>
                        <Count>
                            <InputCount ref={nameInputRef} value={nameInputRef?.current?.value || 0} />
                        </Count>
                        <Plus onClick={handlePlus}>+</Plus>
                    </TicketButtons>
                    <TicketPrice>{formatMoneyToCZK(Math.round(totalPrice * 100) / 100)} Kč</TicketPrice>
                </TicketDetails>
            </TicketContent>
        </Ticket>
    );
};

export default ConferenceOrderTicketTemplate;
